/**
 * Time windows. A window is the unit of key wrapping and of unlock grants.
 * Window ids are compact UTC timestamps of the window start, safe for object paths.
 */
export const ALLOWED_WINDOW_MINUTES = [1, 5, 10, 15, 30, 60];
export const DEFAULT_WINDOW_MINUTES = 15;
export function assertWindowMinutes(m) {
    if (!ALLOWED_WINDOW_MINUTES.includes(m)) {
        throw new RangeError(`window minutes must be one of ${ALLOWED_WINDOW_MINUTES.join(", ")}`);
    }
}
export function windowStartMs(tsMs, windowMinutes) {
    assertWindowMinutes(windowMinutes);
    const ms = windowMinutes * 60_000;
    return Math.floor(tsMs / ms) * ms;
}
function pad(n, w) {
    return String(n).padStart(w, "0");
}
/** e.g. 20260912T2015Z */
export function windowIdFromStart(startMs) {
    const d = new Date(startMs);
    return (`${pad(d.getUTCFullYear(), 4)}${pad(d.getUTCMonth() + 1, 2)}${pad(d.getUTCDate(), 2)}` +
        `T${pad(d.getUTCHours(), 2)}${pad(d.getUTCMinutes(), 2)}Z`);
}
export function windowIdFor(tsMs, windowMinutes) {
    return windowIdFromStart(windowStartMs(tsMs, windowMinutes));
}
const WINDOW_ID_RE = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})Z$/;
export function windowIdToStartMs(id) {
    const m = WINDOW_ID_RE.exec(id);
    if (!m)
        throw new RangeError(`invalid window id: ${id}`);
    return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]));
}
export function isWindowId(id) {
    return WINDOW_ID_RE.test(id);
}
/** All window ids that intersect [fromMs, toMs). */
export function windowIdsInRange(fromMs, toMs, windowMinutes) {
    if (toMs <= fromMs)
        return [];
    const ms = windowMinutes * 60_000;
    const out = [];
    for (let t = windowStartMs(fromMs, windowMinutes); t < toMs; t += ms)
        out.push(windowIdFromStart(t));
    return out;
}
/** Date path segment for a window id: yyyy/mm/dd */
export function datePath(windowId) {
    const m = WINDOW_ID_RE.exec(windowId);
    if (!m)
        throw new RangeError(`invalid window id: ${windowId}`);
    return `${m[1]}/${m[2]}/${m[3]}`;
}
//# sourceMappingURL=window.js.map